import { applyThemeCssVars } from './themePalette';

applyThemeCssVars();
